module.exports = __webpack_public_path__ + "assets/img/拍摄@3x.35828e9f.png";